"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {TitleSectionEspaceProLarge} from "@/components/common/title-section-espace-pro";
import {Button} from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Notre Outil de Développement des Territoires"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            <SectionPage sectionType="lg" className={"mt-6"}>
                <TitleSectionEspaceProLarge title={"Comprendre le contrat de destination en 6 points"} />

                <Button variant={"bleuMarine"} onClick={() => navigate("/pdf-viewer/LE-CONTRAT-DE-DESTINATION.pdf")}>Consulter le contrat de destination</Button>
            </SectionPage>

            <SectionPage sectionType="lg" className={"mt-6"}>
                <TitleSectionEspaceProLarge title={"Carte heuristique"} />

                <img src={"/images/espace-pro/office-du-tourisme/plans-actions-rapports-activites/CARTE-HEURISTIQUE-1024x686.jpg"} width={1080} height={1000} alt={"Carte heuristique"}
                       />
            </SectionPage>

        </div>
    );
}
